import React from 'react';
export function TestimonialCarousel() {
  const testimonials = [{
    quote: "People started asking me if I'd been on vacation. I hadn't. I just looked rested in a way I hadn't since my twenties. One treatment.",
    author: 'Patient, Walnut Creek CA'
  }, {
    quote: "The redness I've struggled with for a decade vanished. It feels like I got my original skin back.",
    author: 'Patient, Danville CA'
  }, {
    quote: 'I stopped wearing foundation entirely. The tone is so even, I just use sunscreen and walk out the door.',
    author: 'Patient, San Ramon CA'
  }];
  return <section className="py-24 md:py-32 bg-brand-bg overflow-hidden" data-id="element-173">
      <div className="container px-4 md:px-6" data-id="element-174">
        <div className="text-center mb-12 text-brand-gold/30" data-id="element-175">
          <svg className="w-16 h-16 md:w-24 md:h-24 mx-auto fill-current" viewBox="0 0 24 24" data-id="element-176">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-177" />
          </svg>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar pb-8 -mx-4 px-4 md:mx-0 md:px-0" data-id="element-178">
          {testimonials.map((item, index) => <div key={index} className="min-w-full md:min-w-0 md:w-full flex-shrink-0 snap-center flex flex-col items-center text-center px-4 md:px-12" data-id="element-179">
              <blockquote className="font-playfair italic text-2xl md:text-3xl lg:text-4xl text-brand-text leading-relaxed max-w-4xl mx-auto mb-8" data-id="element-180">
                "{item.quote}"
              </blockquote>
              <cite className="font-sans text-sm md:text-base text-brand-text/60 uppercase tracking-widest not-italic" data-id="element-181">
                — {item.author}
              </cite>
            </div>)}
        </div>

        {/* Simple pagination dots indicator (visual only for this static version) */}
        <div className="flex justify-center gap-2 mt-4 md:hidden" data-id="element-182">
          {testimonials.map((_, i) => <div key={i} className={`w-2 h-2 rounded-full ${i === 0 ? 'bg-brand-gold' : 'bg-brand-divider'}`} data-id="element-183" />)}
        </div>
      </div>
    </section>;
}